import PropTypes from 'prop-types';
/**
 * A positioning component wrapper that positions the given `hoverElement` relatively to its wrapped children
 * Used by components like DropdownButton and Tooltip.
 */
import React from 'react';
import HoverCard from './HoverCard';

import * as elementPosition from '../lib/elementPosition';
import { getComponentClasses } from '@99designs/utils/app';
import { uniqueId } from 'lodash';

export default class HoverableElement extends React.Component {
    render() {
        var classes = getComponentClasses('hover-card-anchor', this.props.variations);
        var id = uniqueId('hoverable_');
        return (
            <span className={classes} id={id}>
                {this.props.children}
                <HoverCard
                    anchorNodeSelector={'#' + id}
                    alignmentOffset={this.props.alignmentOffset}
                    hasTransition={this.props.hasTransition}
                    hasAnimation={false}
                    hoverPosition={this.props.hoverPosition}
                    isActive={this.props.isActive}
                    type={this.props.type}
                    onShow={this.props.onHoverElementShow}
                    onHide={this.props.onHoverElementHide}
                    variations={this.props.hoverCardVariations}
                    >
                    {this.props.hoverElement}
                </HoverCard>
            </span>
        );
    }
}

HoverableElement.propTypes = {
    alignmentOffset: PropTypes.number,
    hasTransition: PropTypes.bool,
    hoverElement: PropTypes.element.isRequired,
    hoverPosition: PropTypes.oneOf(elementPosition.getPossiblePositions()),
    isActive: PropTypes.bool,
    type: PropTypes.oneOf(['tooltip', 'dropdown']),
    onHoverElementShow: PropTypes.func,
    onHoverElementHide: PropTypes.func,
    variations: PropTypes.array,
    hoverCardVariations: PropTypes.array,
};

HoverableElement.defaultProps = {
    alignmentOffset: 0,
    hasTransition: false,
    hoverPosition: 'down-center',
    isActive: false,
    type: 'tooltip',
    variations: [],
    hoverCardVariations: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/HoverableElement.jsx